import {
  BottomImage,
  ImagesContainer,
  ImagesSkeleton,
  ResultImages,
  SingleImage,
  TopImage,
} from './styled';

type Props = {
  images: (string | undefined)[];
  isLoading?: boolean;
};

const BundleImages = ({ images, isLoading }: Props) => {
  const [primaryImage, secondaryImage] = images;
  const hasSecondaryImage = !!secondaryImage;

  if (isLoading) {
    return (
      <ImagesContainer>
        <ImagesSkeleton />
      </ImagesContainer>
    );
  }

  if (hasSecondaryImage) {
    return (
      <ResultImages>
        <TopImage src={primaryImage} />
        <BottomImage src={secondaryImage} />
      </ResultImages>
    );
  }

  return (
    <ImagesContainer>
      <SingleImage src={primaryImage} />
    </ImagesContainer>
  );
};

export default BundleImages;
